<template>
    <span>{{ cartItemsCount }}</span>
</template>

<script type="text/jsx">
    export default {
        name: 'cart-bag',
        computed: {
            cartItemsCount () {
                return this.$store.getters.cartItemsCount;
            }
        }
    }</script>

<style>
</style>



// WEBPACK FOOTER //
// CartBag.vue?4fe19682